import React, { useState } from "react";
import { Table, Divider, Space, Popconfirm, Modal, Image, Tag, Button, Tooltip, Spin } from "antd";
import { useTranslation } from "react-i18next";
import { QrcodeOutlined, CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { permissionsFilter } from "../../../utils/permissionsFilter";
import { toastNotification } from "../../../utils/toastNotification";
import QRCode from "react-qr-code";
import ApiConstants from "../../../api/ApiConstants";
import Api from "../../../api";
import Eye from "../../../public/images/dashboard/tables/eye.svg";
import Delete from "../../../public/images/dashboard/tables/delete.svg";
import "../../../public/sass/layout/_index.scss";

const PositionsTable = ({
  products,
  loading,
  getProductById,
  deleteProduct,
  handleGetAllProducts,
  reloadProducts,
  total,
  handlePagination,
  handleTableChange
}) => {
  const { t, i18n } = useTranslation();

  const [isQRCode, setQRCode] = useState(false);
  const [name, setName] = useState("");

  const [validationModalVisible, setValidationModalVisible] = useState(false);
  const [validationProduct, setValidationProduct] = useState(null);
  const [validationLoading, setValidationLoading] = useState(false);
  const [fetchingProduct, setFetchingProduct] = useState(false);

  const renderConfidenceTag = (confidence) => {
    if (confidence === null || confidence === undefined) return null;
    const color = confidence >= 80 ? "green" : confidence >= 60 ? "orange" : "red";
    return <Tag color={color} style={{ fontSize: 11 }}>{confidence}%</Tag>;
  };

  const openValidationModal = (record) => {
    setFetchingProduct(true);
    setValidationProduct(null);
    setValidationModalVisible(true);
    Api("products/" + record.id, "GET")
      .then((data) => {
        setValidationProduct(data);
      })
      .catch((err) => {
        toastNotification("error", err?.error || t("something_went_wrong"));
        closeValidationModal();
      })
      .finally(() => setFetchingProduct(false));
  };

  const closeValidationModal = () => {
    setValidationModalVisible(false);
    setValidationProduct(null);
  };

  const handleValidate = (id, status) => {
    setValidationLoading(true);
    Api("products/" + id + "/validate", "PATCH", { status })
      .then(() => {
        toastNotification(
          "success",
          status === "approved"
            ? t("product_approved_successfully")
            : t("product_rejected_successfully")
        );
        closeValidationModal();
        reloadProducts();
      })
      .catch((err) => {
        toastNotification("error", err?.error || t("something_went_wrong"));
      })
      .finally(() => setValidationLoading(false));
  };

  const handleStatus = (status) => {
    switch (status) {
      case 0:
        return {
          color: "#13c2c2",
          item: t("status_accepted"),
        };
      case 1:
        return {
          color: "#cf1322",
          item: t("status_not_accepted"),
        };
      case 2:
        return {
          color: "#1890ff",
          item: t("status_in_progress"),
        };
      case 3:
        return {
          color: "#389e0d",
          item: t("status_done"),
        };
      case 4:
        return {
          color: "#820014",
          item: t("status_not_active"),
        };
      default:
        return {
          color: "#820014",
          item: t("status_not_active"),
        };
    }
  };

  const columns = [
    {
      title: "Bild",
      dataIndex: "images",
      key: "images",
      render: (img) => {
        if (img) {
          const imgParse = JSON.parse(img);
          return (
            <Image
              src={ApiConstants.IMAGE_URL + imgParse[0]}
              width={100}
              fallback="data:image/png;base64,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"
            />
          );
        } else {
          return (
            <Image
              src={
                "data:image/png;base64,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"
              }
              width={100}
              fallback="data:image/png;base64,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"
            />
          );
        }
      },
    },
    {
      title: "Nr",
      dataIndex: "product_id",
      key: "product_id",
      render: (product_id) => <>P{product_id}</>,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a?.name.length - b?.name.length,
    },
    {
      title: "Beschreibung",
      dataIndex: "short_description",
      key: "short_description",
      sorter: (a, b) =>
        a?.short_description?.length - b?.short_description?.length,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: (a, b) => a.status - b.status,
      render: (status) => (
        <>
          <a style={{ color: `${handleStatus(status).color}` }}>
            {handleStatus(status).item}
          </a>
        </>
      ),
    },
    {
      title: "QR Code",
      dataIndex: "name",
      key: "name",
      render: (name) => (
        <>
          <a style={{ paddingLeft: 15 }}>
            <QrcodeOutlined
              onClick={() => {
                setName(name);
                setQRCode(!isQRCode);
              }}
              style={{ fontSize: 20 }}
            />
          </a>
        </>
      ),
    },
    {
      title: "Aktion",
      key: "action",
      fixed: "right",
      width: 160,
      render: (e) => (
        <Space size="middle">
          {e.validation_status === "pending" && (
            <Tooltip title={t("ai_validation_queue")}>
              <Button
                type="primary"
                size="small"
                icon={<CheckOutlined />}
                onClick={() => openValidationModal(e)}
                style={{ backgroundColor: "#52c41a", borderColor: "#52c41a" }}
              />
            </Tooltip>
          )}
          {permissionsFilter("Products", "ProductUpdate") && (
            <a onClick={() => getProductById(e?.id)}>
              <img src={Eye} alt="Edit" />
            </a>
          )}
          {permissionsFilter("Products", "ProductDelete") && (
            <Popconfirm
              title={t("are_you_sure")}
              onConfirm={() => deleteProduct(e?.id)}
            >
              <a>
                <img src={Delete} alt="Delete" />
              </a>
            </Popconfirm>
          )}
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Divider />
      <Table
        showSorterTooltip={{ title: t("click_sort") }}
        loading={loading}
        columns={columns}
        dataSource={products}
        onChange={handleTableChange}
        className="table"
        pagination={{
          total: total,
        }}
        scroll={{ y: ApiConstants.TABLE_HEIGHT }}
      />
      <Modal
        width={350}
        style={{ textAlign: "center" }}
        title={name}
        centered
        visible={isQRCode}
        onOk={() => setQRCode(!isQRCode)}
        onCancel={() => setQRCode(!isQRCode)}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <QRCode size={150} value={Math.floor(Math.random() * 100000 + 1)} />
        </div>
      </Modal>

      <Modal
        title={validationProduct?.name || ""}
        visible={validationModalVisible}
        onCancel={closeValidationModal}
        footer={null}
        width={500}
      >
        {fetchingProduct ? (
          <div style={{ textAlign: "center", padding: 40 }}>
            <Spin size="large" />
          </div>
        ) : validationProduct && (
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            {validationProduct.import_job_id && (
              <Tag color="blue" style={{ textAlign: "center", display: "block", width: "fit-content", margin: "0 auto" }}>
                {t("from_excel_import")}
              </Tag>
            )}

            {validationProduct.category?.name && (
              <div style={{ textAlign: "center" }}>
                <small>{t("category")}</small>
                <div style={{ fontSize: 16, fontWeight: 500 }}>
                  {validationProduct.category.name}
                </div>
              </div>
            )}

            <div style={{ display: "flex", gap: 12 }}>
              {[
                { label: t("breakdown_value"), value: validationProduct.breakdown_value, confidence: validationProduct.ai_confidence_breakdown },
                { label: t("going_concern_value"), value: validationProduct.going_concern_value, confidence: validationProduct.ai_confidence_going_concern },
                { label: t("market_value"), value: validationProduct.market_value, confidence: validationProduct.ai_confidence_market },
              ].map((item, idx) => (
                <div key={idx} style={{ flex: 1, background: "#fff", padding: "12px 8px", borderRadius: 4, textAlign: "center", border: "1px solid #f0f0f0" }}>
                  <div style={{ fontSize: 12, color: "#888", marginBottom: 4, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                    {item.label}
                  </div>
                  <div style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>
                    {item.value ? `€${Number(item.value).toLocaleString()}` : "-"}
                  </div>
                  <div>{renderConfidenceTag(item.confidence)}</div>
                </div>
              ))}
            </div>

            {validationProduct.ai_processed_at && (
              <div style={{ textAlign: "center", color: "#888", fontSize: 12 }}>
                {t("ai_generated_at")}: {new Date(validationProduct.ai_processed_at).toLocaleString()}
              </div>
            )}

            {validationProduct.ai_reasoning && (
              <div style={{ background: "#fff", padding: 12, borderRadius: 4, border: "1px solid #f0f0f0" }}>
                <div style={{ fontWeight: 600, marginBottom: 6, fontSize: 13 }}>{t("ai_reasoning")}</div>
                <div style={{ fontSize: 13, color: "#555", whiteSpace: "pre-wrap", lineHeight: 1.6 }}>
                  {(() => {
                    try {
                      const parsed = JSON.parse(validationProduct.ai_reasoning);
                      return Object.entries(parsed)
                        .map(([k, v]) => `${k}: ${v}`)
                        .join("\n");
                    } catch {
                      return validationProduct.ai_reasoning;
                    }
                  })()}
                </div>
              </div>
            )}

            <div style={{ textAlign: "center" }}>
              <Space size="middle">
                <Button
                  type="primary"
                  icon={<CheckOutlined />}
                  onClick={() => handleValidate(validationProduct.id, "approved")}
                  loading={validationLoading}
                >
                  {t("approve")}
                </Button>
                <Button
                  danger
                  icon={<CloseOutlined />}
                  onClick={() => handleValidate(validationProduct.id, "rejected")}
                  loading={validationLoading}
                >
                  {t("reject")}
                </Button>
              </Space>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};
export default PositionsTable;